import { registerLocaleData } from '@angular/common';
import { Injectable } from '@angular/core';
import { CommonConstants } from '../constants/common.constants';

@Injectable({
  providedIn: 'root'
})
export class LocalizationService {
  public formatCulture!: string;

  constructor() {}

  public async setLocaleWithBrowserLanguage(): Promise<void> {
    const browserLanguage = navigator.language || CommonConstants.DefaultLanguageCode;
    try {
      await this.setCurrentCulture(browserLanguage);
    } catch {
      this.formatCulture = 'en-US';
      return;
    }
    this.formatCulture = browserLanguage;
  }

  public async setLocaleWithUserLanguage(language: string | undefined): Promise<void> {
    const userLanguage = language ?? 'en-US';
    try {
      await this.setCurrentCulture(userLanguage);
    } catch {
      this.formatCulture = 'en-US';
      return;
    }
    this.formatCulture = userLanguage;
  }

  private async setCurrentCulture(localeId: string): Promise<void> {
    try {
      const localeModule = await import(
        /* webpackInclude: /\.mjs$/ */
        /* webpackExports: "default" */
        /* webpackChunkName: "locale" */
        `node_modules/@angular/common/locales/${localeId}`
      );
      registerLocaleData(localeModule.default);
      return;
    } catch {}
    try {
      const localeModule1 = await import(
        /* webpackInclude: /\.mjs$/ */
        /* webpackExports: "default" */
        /* webpackChunkName: "locale" */
        `node_modules/@angular/common/locales/${localeId.split('-')[0]}`
      );
      registerLocaleData(localeModule1.default);
    } catch {}
  }
}
